import Icon from "assets/icons";
import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import { ActionCountBarTypes } from "./type";

export default function ActionCountBar(props: ActionCountBarTypes) {
  const copies = useCopies();

  return (
    <React.Fragment>
      {props.pendingCount === 0 ? (
        <div className="actionCountBar actionCountBar_actions--completed">
          <Icon.CheckOutlined />
          {props.showCompletedCount ? (
            <span>
              {copies.get("items.completed", {
                0: props.completedCount,
                1: props.totalCount
              })}
            </span>
          ) : (
            <span>{copies.get("all.actions.completed")}</span>
          )}
        </div>
      ) : (
        <div className="actionCountBar actionCountBar_actions--pending">
          <Icon.ExclamationCircle />
          <span>
            {copies.get("pending.items.requires.action", {
              0: props.pendingCount,
              1: props.totalCount
            })}
          </span>
        </div>
      )}
    </React.Fragment>
  );
}
